import PropTypes from 'prop-types';
import React from 'react';

import { BASE_PATH_2_QUERY, TEMPLATE_QUERY } from '@glass/common/modules/pages/queryParams';
import { CUSTOM_TEMPLATE_SECTION_ID } from '@glass/web/modules/content/pages/contentIds';
import { CONTACT_SECTION } from '@glass/web/modules/resumes/router/sections';
import { CREATE_YOUR_OWN_TEMPLATE } from '@glass/web/modules/resumes/templates/templateKeys';

import ResumeBuilderLink from '@glass/shared/components/Link/ResumeBuilderLink/ResumeBuilderLink';
import Section from '@glass/shared/components/Section/Section';
import SectionButtonCta from '@glass/shared/components/Section/SectionButtonCta';
import SectionSpacer, { BOTTOM_EDGE } from '@glass/shared/components/Section/SectionSpacer';
import { TEMPLATE_CONTENT_WORD } from '@glass/shared/modules/content/staticVariations/contentWords/contentWordVariations';
import useVerbWords from '@glass/shared/modules/content/staticVariations/verbWords/useVerbWords';
import withTrackingContext from '@glass/shared/modules/tracking/withTrackingContext';

const params = {
  [TEMPLATE_QUERY]: CREATE_YOUR_OWN_TEMPLATE,
  [BASE_PATH_2_QUERY]: CONTACT_SECTION,
};

const CustomTemplateSection = React.forwardRef(
  ({ title, subtitle, isAlternatingColor, type }, ref) => {
    const verbWords = useVerbWords();

    return (
      <Section
        ref={ref}
        disableCta
        isAlternatingColor={isAlternatingColor}
        subtitle={subtitle}
        title={title}
        type={type}
      >
        <SectionSpacer edge={BOTTOM_EDGE}>
          <SectionButtonCta component={ResumeBuilderLink} params={params}>
            {verbWords.capitalized} your own {TEMPLATE_CONTENT_WORD}
          </SectionButtonCta>
        </SectionSpacer>
      </Section>
    );
  },
);

CustomTemplateSection.propTypes = {
  isAlternatingColor: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};

CustomTemplateSection.defaultProps = {
  title: `$(verbWords.capitalized) your own <b>template</b>`,
  subtitle: `Use our advanced editor to customize & $(verbWords.singular) your own $(resumeWords.singular) template just right for you`,
};

export default React.memo(withTrackingContext(CustomTemplateSection, CUSTOM_TEMPLATE_SECTION_ID));
